import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { requestWorkroom } from 'actionCreators';
import Loading from 'components/Loading';
import WorkroomDetailsCard from './components/workroomDetailsCard';
import { getRole, getWorkroomById } from '../../../../reducers';
import { can } from '../../../../services';
import connectUI from 'redux-ui';
import MessageBox from 'components/MessageBox';

class WorkroomDetails extends React.Component {
  componentDidMount = () => this.props.requestWorkroom(this.props.id);

  componentWillUnmount = () => (this.props.ui.successMessage ? this.props.updateUI('successMessage', '') : null);

  render = () => {
    const { loading, workroom, canEdit, ui, role } = this.props;
    return (<div>
      {ui.successMessage ? <MessageBox message={ui.successMessage} /> : null}
      {loading ? <Loading /> : <WorkroomDetailsCard
        canEdit={canEdit} workroom={workroom} users={workroom.users} role={role}
      />}
    </div>);
  }
}

WorkroomDetails.propTypes = {
  loading: PropTypes.bool,
  canEdit: PropTypes.bool,
  workroom: PropTypes.object,
  ui: PropTypes.object,
  updateUI: PropTypes.func,
  id: PropTypes.number,
  requestWorkroom: PropTypes.func,
  role: PropTypes.string,
};

function mapStateToProps(state, ownProps) {
  const id = Number(ownProps.params.id);
  const workroom = getWorkroomById(state)(id);
  const loading = workroom ? workroom.loading : true;
  const role = getRole(state);
  return {
    id,
    workroom,
    canEdit: can(role, 'update', 'workroom'),
    role,
    loading,
  };
}

export default connectUI()(connect(mapStateToProps, { requestWorkroom })(WorkroomDetails));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/workrooms/workroomDetails.jsx